/**
 * OrderInfoSection Component
 *
 * Form section for supplier selection and expected delivery date.
 */

import { Select } from '@/components/ui';
import { DatePicker, type DateRange } from '@/components/ui';

interface OrderInfoSectionProps {
  supplierId: string;
  expectedDateRange: DateRange;
  supplierOptions: { value: string; label: string }[];
  suppliersLoading: boolean;
  isEditMode: boolean;
  onSupplierChange: (value: string) => void;
  onExpectedDateChange: (range: DateRange) => void;
}

export function OrderInfoSection({
  supplierId,
  expectedDateRange,
  supplierOptions,
  suppliersLoading,
  isEditMode,
  onSupplierChange,
  onExpectedDateChange,
}: OrderInfoSectionProps) {
  return (
    <div className="bg-neutral-50 rounded-lg border border-neutral-200 p-6">
      <div className="grid grid-cols-2 gap-6">
        <Select
          label="Fournisseur *"
          value={supplierId}
          onChange={onSupplierChange}
          options={supplierOptions}
          placeholder="Selectionner un fournisseur"
          disabled={suppliersLoading || isEditMode}
        />
        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-1">
            Livraison souhaitee
          </label>
          <DatePicker
            asSingle
            showTime
            value={expectedDateRange}
            onChange={onExpectedDateChange}
            placeholder="Selectionner une date"
          />
        </div>
      </div>
    </div>
  );
}
